
;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');
	View.TippingLeaguesSettings = View.LeaguesSettings.extend({
		template: JST.TippingLeaguesSettings,
		form_template: JST.TippingLeaguesSettingsForm,
		ui: {
			'form':              '#js-league-edit-form',
			'update_submit':     '#js-league-update',
			'remove_submit':     '#js-league-remove',
			'combination_error': '#js-combination-error'
		}
	});
}(window, APP, Backbone, Marionette, $, _));